import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, map } from "rxjs";
import { environment } from "src/environments/environment.prod";

@Injectable({
  providedIn: "root",
})
export class TruckOwnerService {
  public data = new BehaviorSubject<any>(null);
  public share = this.data.asObservable();

  constructor(private httpClient: HttpClient) { }

  latestLocation(token: any, id: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trip-booking/latest-location/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getLocationHistory(token: any, tripId: string) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient.get(
      `${environment.base_url}${environment.base_uri}trips/admin/location-history/${tripId}`,
      { headers: header }
    );
  }

  tracking(token: any, id: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}customer/trip/${id}/track`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  transporterLogin(loginData: any) {
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}verification`,
        loginData
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  OTPVerify(data: any, id: any) {
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truckowner/verify/${id}`,
        data
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  newRegister(data: any, id: any): Observable<any> {
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truckowner/register/${id}`,
        data,
        { observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  uploadImage(file: any): Observable<any> {
    var fd = new FormData();
    fd.append("upload", file);
    return this.httpClient
      .post(`${environment.base_url}${environment.base_uri}upload`, fd, {
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetLanguageID(): Observable<any> {
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}drivers/languages/known/list`
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetProfile(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}truckowner`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  UpdateProfile(profileData: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}truckowner`,
        profileData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  accountDelete(userType: any, data: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}profile/userstatus?status=${userType}&mobile=${data}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GettruckOwner(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}truckowner`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetTypeTruck(id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truck-details/admin/cat/type/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  AddTruck(truckObj: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}trucks/truckowner`,
        truckObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetCategory(): Observable<any> {
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truck-details/category`,
        { observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetTruckOwner(): Observable<any> {
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}admin/truckowner`, {
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetTrucksType(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truck-details/admin/tructype`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetTruckownerTrucksType(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}trucks/trucktype`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getTrucks(token: any, truckType: any, truckNumber: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trucks/truckowner?truck_status=${truckType}&search_query=${truckNumber}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getTruckownerTrucks(
    token: any,
    truckType: any,
    truckNumber: any,
    startPage: any,
    perpage: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trucks/truckowner?truck_status=${truckType}&search_query=${truckNumber}&page=${startPage}&perPage=${perpage}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  truckDelete(id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}trucks/truckowner/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  truckUpdate(updateTruckObj: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}trucks/truckowner/${id}`,
        updateTruckObj,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  MobileTruckOwnerOTPVerify(data: any, id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truckowner-driver/verify/${id}`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getDriverList(
    token: any,
    driverType: any,
    driverNumber: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner-driver?driver_status=${driverType}&search_query=${driverNumber}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getTruckownerDriverList(
    token: any,
    driverType: any,
    driverNumber: any,
    startPage: any,
    perPage: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner-driver?driver_status=${driverType}&search_query=${driverNumber}&page=${startPage}&perPage=${perPage}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetAvailableTrucks(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trucks/truckowner/available`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetAvailableDrivers(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner-driver/available`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetMappingsList(token: any, truckNumber: any, perPage: any, page: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner-mapping?truckNo=${truckNumber}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  AddDriver(driverData: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truckowner-driver/register/${id}`,
        driverData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  EditDriver(driverData: any, token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}truckowner-driver/update/${id}`,
        driverData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  driverDelete(id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}truckowner-driver/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  AddMappings(token: any, data: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truckowner-mapping`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  DeleteMappings(token: any, id: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}truckowner-mapping/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  ordersGet(token: any, orderType: any, page: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/trips?from_date=-1&to_date=-1&truck_number=-1&status=${orderType}&trip_id=-1&perPage=10&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  dashboard(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/dashboard`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  paymentsGet(
    dataObj: any,
    status: any,
    trip_id: any,
    perPage: any,
    page: any,
    token: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/trips?from_date=${dataObj.from_date}&to_date=${dataObj.to_date}&truck_number=${dataObj.truck_number}&status=${status}&trip_id=${trip_id}&perPage=${perPage}&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  Track(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/trip/track`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  profileGet(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}truckowner`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  taxGet(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}taxes-driver`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  deliveryOrderGet(
    token: any,
    deliverOrderType: any,
    search: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/delivery-orders?status=${deliverOrderType}&search_query=${search}&perPage=10&page=${page}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  addCreditTrip(id: any, data: any, token: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truckowner/credit/trip/${id}`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getVehicleDetails(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/trucks/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  GetVehicle(_id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}admin-workorder/truck/details/${_id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getReportsList(
    token: any,
    fromLocation: string,
    toLocation: string,
    fromDate: any,
    toDate: any,
    lrNo: any,
    vchlNo: any,
    salesOrder: any,
    workOrderNo: any,
    selectedTripData: any,
    tripStatusDetails: any,
    download: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/reports?&fromLocation=${fromLocation}&toLocation=${toLocation}&fromDate=${fromDate}&toDate=${toDate}&lrNo=${lrNo}&vchlNo=${vchlNo}&salesOrderNo=${salesOrder}&workOrderNo=${workOrderNo}&tripId=${selectedTripData}&tripStatus=${tripStatusDetails}&download=${download}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  listDropDown(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/reports/masterdata`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  creditTripGet(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/tripDetails/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  updateCreditTrip(profileData: any, id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}truckowner/update/trips/${id}`,
        profileData,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  accountRestore(restoreUser: any, data: any): Observable<any> {
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}profile/userstatus?status=${restoreUser}&mobile=${data}`,
        {
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  logoutTransporter(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}truckowner/logout`, {
        headers: header,
        observe: "response",
      })
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  tripCancel(id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/changeStatus/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  emailRequest(emailData: any) {
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}verification/truckowner/driver/sendotp`,
        emailData
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  EmailOTPVerify(data: any, id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truckowner-driver/verify/${id}`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GettruckLastLocation(tripId: any): Observable<any> {
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/trip/${tripId}/track`
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  // Pre Order Settings //

  getCategory(): Observable<any> {
    return this.httpClient
      .get(`${environment.base_url}${environment.base_uri}trucks/categories`)
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  addRoute(data: any, token: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truckowner/createPreorder`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  preOrderSetting(token: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/preorder/lists`,

        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  deletePreOrderSetting(id: any, token: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}truckowner/preorder/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  // Pre Order Api's  //


  getActiveOrders(
    token: any,
    search: any,
    page: any,
    from_lat?: string,
    from_long?: string,
    to_lat?: string,
    to_long?: string,
    truckCategory?: string
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    let url = `${environment.base_url}${environment.base_uri}truckowner/ActiveOrders?wo_id=${search}&page=${page}&perPage=10`;
    if (from_lat !== undefined) {
      url += `&from_lat=${from_lat}`;
    }
    if (from_long !== undefined) {
      url += `&from_long=${from_long}`;
    }
    if (to_lat !== undefined) {
      url += `&to_lat=${to_lat}`;
    }
    if (to_long !== undefined) {
      url += `&to_long=${to_long}`;
    }
    if (truckCategory !== undefined) {
      url += `&truckCategory=${truckCategory}`;
    }
    return this.httpClient
      .get(
        url,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getPreOrder(
    token: any,
    search: any,
    deliverOrderType: any,
    page: any
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/workorderdetails/all?wo_id=${search}&page=${page}&perPage=10`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getPreorderTrucks(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trucks/truckowner/wo-allocated/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getQuoteTrucks(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trucks/truckowner/quote-allocated/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getAvailableTrucks(token: any, categoryId: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trucks/truckowner/available-trucks/${categoryId}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetPreorderTruckType(id: any, token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/select/truckByid/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  addPreOrderBidRate(data: any, token: string) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truckowner/workorder/bidrate`,
        data,
        { headers: headers, observe: 'response' }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getBidRate(token: string, workorderId: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });

    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/workorder/bidrate/${workorderId}`,
        {
          headers: headers,
          observe: 'response',
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  updateBidRate(data: any, token: any, id: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}truckowner/workorder/bidrate/${id}`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  deleteBidRate(id: any, token: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });

    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}truckowner/workorder/bidrate/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  addPreOrderTruck(data: any, token: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truckowner/workorder/credittrips`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getPreorderBidList(token: any, id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/workorderbid/List/${id}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  updatePreOrderTruck(data: any, token: any, id: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}truckowner/workorderbid/update/${id}`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  deleteBid(id: any, token: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .delete(
        `${environment.base_url}${environment.base_uri}truckowner/workorderbid/${id}`,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  rejectedBid(data: any, token: any) {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truckowner/workorderbid`,
        data,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getNotificationList(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}notification/notificationDetailList`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  driverApproval(token: any, status: any, refId: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truckowner-driver/driverApproval/${status}/${refId}`,
        {},
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  quoteBid(token: any, notificationId: string, data: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truckowner/quote-bid/${notificationId}`,
        data,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getQuoteBidStatus(token: any, tripId: string): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner/quote-bid/${tripId}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getDriverOrders(
    token?: any,
    dr_status: any = "-1",
    search_query: any = "-1",
    perPage: any = 10,
    page: any = 1,
    trip_status: any = "-1"
  ): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}truckowner-driver/driver-routes/${dr_status}?search_query=${search_query}&perPage=${perPage}&page=${page}&dr_status=${trip_status}`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  getAvailableTrucksForRoute(token: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .get(
        `${environment.base_url}${environment.base_uri}trucks/truckowner/available-for-route`,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  createDriverRoute(token: any, data: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}driver-routes`,
        data,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  cancelDro(cancelPayload: any, token: any, dro_id: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}truckowner/cancel/${dro_id}`,
        cancelPayload,
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  editDriverRoute(dro_id: string, token: any, data: any): Observable<any> {
    let header = new HttpHeaders({
      Authorization: "Bearer " + token,
    });
    return this.httpClient
      .patch(
        `${environment.base_url}${environment.base_uri}truckowner/edit-dro/${dro_id}`,
        data,
        {
          headers: header,
          observe: "response",
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  verifyVehicleRC(rcNumber: string, token?: any): Observable<any> {
    const authToken = token || sessionStorage.getItem("to_token") || "";
    let header = new HttpHeaders({
      Authorization: "Bearer " + authToken,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}master-india/rc`,
        { rcNumber: (rcNumber || "").trim().toUpperCase() },
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  verifyDrivingLicense(dlNumber: string, dob: string, token?: any): Observable<any> {
    const authToken = token || sessionStorage.getItem("to_token") || "";
    let header = new HttpHeaders({
      Authorization: "Bearer " + authToken,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}master-india/dl`,
        { dlNumber: (dlNumber || "").trim().toUpperCase(), dob: (dob || "").trim() },
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  verifyGST(gstin: string, token?: any): Observable<any> {
    const authToken = token || sessionStorage.getItem("to_token") || "";
    let header = new HttpHeaders({
      Authorization: "Bearer " + authToken,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}master-india/gst`,
        { gstin: (gstin || "").trim().toUpperCase() },
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  verifyPAN(pan: string, token?: any): Observable<any> {
    const authToken = token || sessionStorage.getItem("to_token") || "";
    let header = new HttpHeaders({
      Authorization: "Bearer " + authToken,
    });
    return this.httpClient
      .post(
        `${environment.base_url}${environment.base_uri}master-india/pan`,
        { pan: (pan || "").trim().toUpperCase() },
        { headers: header, observe: "response" }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}
